import React, { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import PropTypes from 'prop-types';
import { useOmpDealerContext } from '../OmpDealerProvider';
import TransportInfo from '../TransportInfo';
import TransportDetails from '../TransportDetails';
import { BUSINESS_UNIT } from '../../../_shared/constants/omp';
import ReducerConstants from '../../../_shared/constants/reducers';
import useShipping from '../../../_shared/hooks/useShipping';

const propTypes = {
  tradeDetails: PropTypes.objectOf(PropTypes.any),
  type: PropTypes.oneOf(['info', 'details']).isRequired
};

const defaultProps = {
  tradeDetails: undefined
};

const getDealerId = (ompDealer, tradeDetails, isOMP) => {
  if (!isOMP) return tradeDetails?.dealer?.id;

  const dealerId = ompDealer?.sourceInfo?.find(
    info => info.businessUnit === BUSINESS_UNIT.TRADEREV
  )?.sourceId;
  return dealerId ? parseInt(dealerId, 10) : null;
};

const TransportContainer = ({ type, tradeDetails, badges, tradeId, isOMP }) => {
  const organizationDealer = useSelector(
    state => state[ReducerConstants.ORGANIZATION_DEALER],
    shallowEqual
  );

  const { ompBiddingDealer, isMultiOrgAndEnabled } = useOmpDealerContext();

  const dealerId = useMemo(
    () => getDealerId(ompBiddingDealer, tradeDetails, isOMP),
    [isOMP, ompBiddingDealer, tradeDetails]
  );
  const { data: shippingDetails, isFetching } = useShipping(
    isMultiOrgAndEnabled,
    tradeId,
    dealerId
  );

  return type === 'info' ? (
    <TransportInfo
      variant={shippingDetails?.isShippingPromotion ? 'promo' : 'standard'}
      shippingDetails={shippingDetails}
      transportInfo={tradeDetails?.transportInfo}
      tradeId={tradeId}
      dealerId={dealerId}
      dealerInfo={tradeDetails?.dealer}
      ratingsCount={tradeDetails?.dealer?.ratingCount}
      badges={badges}
      isSameTrade={tradeDetails?.id === tradeId}
      isAtAdesa={tradeDetails?.pickupAddress?.isAdesaPhysicalLocation}
      isOMP={isOMP}
      isFetchingEstimate={isFetching && isMultiOrgAndEnabled}
      isMultiOrgAndEnabled={isMultiOrgAndEnabled}
      tradeDetails={tradeDetails}
    />
  ) : (
    <TransportDetails
      variant={shippingDetails?.isShippingPromotion ? 'promo' : 'standard'}
      shippingDetails={shippingDetails}
      dealer={
        isMultiOrgAndEnabled
          ? shippingDetails?.deliveryAddress
          : organizationDealer
      }
      dealerId={dealerId}
      dealerInfo={tradeDetails?.dealer}
      transportInfo={tradeDetails?.transportInfo}
      isAtAdesa={tradeDetails?.pickupAddress?.isAdesaPhysicalLocation}
      isFetchingEstimate={isFetching && isMultiOrgAndEnabled}
      isMultiOrgAndEnabled={isMultiOrgAndEnabled}
      isOMP={isOMP}
      tradeDetails={tradeDetails}
      tradeId={tradeId}
    />
  );
};

TransportContainer.propTypes = propTypes;
TransportContainer.defaultProps = defaultProps;

export default TransportContainer;
